// extracted by mini-css-extract-plugin
module.exports = {"checkWrapper":"styles_checkWrapper__WU1Kc","checkContainer":"styles_checkContainer__HnJzz"};